<template>
  <div class="mvp-tab-panel">
    <BaseTable
      :items="report"
      :columns="columns"
      :loading="loading"
      :title="`Report (${report.length})`"
      accent="linear-gradient(180deg, #6d28d9, #a855f7)"
      :show-count="false"
      :sortable="true"
      :striped="true"
      :hover="true"
      :sticky-header="false"
      :default-sort="defaultSort"
      empty-text="No agents found for this organisation in the selected period."
    >
      <template #cell-products="{ value }">
        <ProductsCell :value="value" />
      </template>
    </BaseTable>
  </div>
</template>

<script>
import ProductsCell from './ProductsCell.vue'

export default {
  name: 'ReportTab',
  components: { ProductsCell },
  props: {
    report: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      defaultSort: { column: 'orders', direction: 'desc' }
    }
  },
  computed: {
    columns () {
      return [
        { key: 'sl_no',    label: 'Sl No',    width: '70px',  sortable: false },
        { key: 'agent',    label: 'Agent' },
        { key: 'orders',   label: 'Orders',   width: '120px', align: 'right', format: 'number' },
        { key: 'amount',   label: 'Amount',   width: '160px', align: 'right', format: 'currency' },
        { key: 'products', label: 'Products' }
      ]
    }
  }
}
</script>

<style scoped>
.mvp-tab-panel {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.mvp-tab-panel >>> .base-table tbody td:nth-child(5) {
  white-space: normal;
  min-width: 280px;
}
</style>
